
  import moment from "moment";
  import PageDetailHeader from '@/components/core/PageDetailHeader';
  import locationModal from '@/components/modals/locationModal.vue';
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import ReviewCard2 from '@/components/ReviewSection/ReviewCard2'
  import loaderComponent from '@/components/loaderComponent'
  import RestaurantCard from '@/components/RestaurantCard'
  import CoolLightBox from "vue-cool-lightbox";
  import CheckoutModal from '@/components/modals/CheckoutModal';
  import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
  // import googleAd from '@/components/gAdUnitCode'
  export default {
    layout: 'detailsPage',
    scrollToTop: true,
    components: {
        PageDetailHeader,
        locationModal,
        VueSlickCarousel,
        ReviewCard2,
        loaderComponent,
        RestaurantCard,
        CoolLightBox,
        CheckoutModal
    },
    head() {
        return {
            title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
            meta: [{
                hid: 'description',
                name: 'description',
                content: this.metaDesc()
            },
            {
                hid: 'keywords',
                name: 'keywords',
                content: this.metaKeywords()
            },
            {
                hid: 'image',
                property: 'image',
                content: this.metaImage()
            },
            {
                hid: 'og:title',
                property: 'og:title',
                content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
            },
            {
                hid: 'og:image',
                property: 'og:image',
                content: this.metaImage()
            },
            {
              hid: 'og:image:secure_url',
              property: 'og:image:secure_url',
              content: this.metaImage()
            },
            {
                hid: 'og:description',
                property: 'og:description',
                content: this.metaDesc()
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
            },
            {
                hid: 'twitter:description',
                property: 'twitter:description',
                content: this.metaDesc()
            }
            ],
        }
    },
    jsonld() {
        if (!this.listings) {
            return null;
        }
        return {
            '@context': 'https://schema.org',
            "@graph": [
                  {
                      "@type": "WebPage",
                      "@id": `https://goa.app/recipe/${this.activitySlug}/#webpage`,
                      "url": `https://goa.app/recipe/${this.activitySlug}`,
                      "name": this.listings && this.listings.post && this.listings.post.title ? this.listings.post.title : 'Recipe Goa App',
                      "description":  this.listings && this.listings.post && this.listings.post.shortDescription ? this.listings.post.shortDescription : 'Recipe Goa App',
                      "image": this.metaImage(),
                      "inLanguage": 'en-US',
                      "datePublished": this.listings && this.listings.post && this.listings.post.createdAt ? this.listings.post.createdAt : new Date(),
                      "dateModified": this.listings && this.listings.post && this.listings.post.createdAt ? this.listings.post.createdAt : new Date(),
                      "author": {
                          "@type": "Person",
                          "@id": "https://goa.app",
                          url: "https://goa.app"
                      },
                  },
                {
                    "@type": "Recipe",
                    "name": this.listings && this.listings.post && this.listings.post.title ? this.listings.post.title : 'Recipe Goa App',
                    "url": `https://goa.app/recipe/${this.activitySlug}`,
                    "image": this.metaImage(),
                    "recipeCuisine": "Goan",
                    "description": this.listings && this.listings.post && this.listings.post.shortDescription ? this.listings.post.shortDescription : 'Recipe Goa App',
                    "prepTime": "PT1H",
                    "cookTime": "PT2H",
                    "totalTime": "PT3H",
                    "datePublished": this.listings && this.listings.post && this.listings.post.createdAt ? this.listings.post.createdAt : new Date(),
                    "keywords": this.metaKeywords(),
                    "recipeYield": "4 servings",
                    "recipeCategory": this.listings && this.listings.post && this.listings.post.categories && this.listings.post.categories.length > 0 ? this.listings.post.categories[0].name : 'Goan Recipe',
                    "nutrition": {
                          "@type": "NutritionInformation",
                          "calories": "1200 calories",
                          "carbohydrateContent": "12 carbs",
                          "proteinContent": "9 grams of protein",
                          "fatContent": "9 grams fat"
                      },
                      "recipeIngredient": this.listings && this.listings.post && this.listings.post.guidelines ? this.listings.post.guidelines.split('\r\n') : 'Recipe Goa App',
                      "recipeInstructions": this.listings && this.listings.post && this.listings.post.shortDescription ? this.listings.post.shortDescription : 'Recipe Goa App',
                      "aggregateRating": {
                          "@type": "AggregateRating",
                          "ratingCount": "250",
                          "ratingValue": this.listings && this.listings.post && this.listings.post.rating ? this.listings.post.rating.averageRating : '5',
                          "reviewCount": this.listings && this.listings.post && this.listings.post.views ? String(this.listings.post.views.count).slice(0, 2) : '5'
                      },
                      publisher: {
                          '@type': 'Organization',
                          name: 'GoaApp',
                          logo: {
                              '@type': 'ImageObject',
                              url: 'https://goa.app/goa-app-logo.svg'
                          }
                      }
                }
            ]
        };
    },
    data() {
        return {
            activitySlug: null,
            listings: null,
            relatedActivities: null,
            relatedPlaces: null,
            reviews: null,
            loading: true,
            offerLoading: true,
            listingLoading: true,
            touristDestSchema: [],
            seoData: null,


            //new
            selectedSec: 'ingredient',
            index: null,
            token: null,
        }
    },
    async validate({
        params,
        store
    }) {
        // await operations
        if (params.slug != (null || "")) {
            this.activitySlug = params.slug;
            return true // if the params are valid
        } else {
            return false // will stop Nuxt.js to render the route and display the error page
        }
    },
    created() {
        this.activitySlug = this.$route.params.slug;
        this.$fetch();
    },
    destroyed() {
        if (document.getElementById('placereviewClose'))
            document.getElementById('placereviewClose').click();
    },
    async fetch() {
        this.seoData = await fetch(this.$config.fetchUrl + '/api/posts/seo/getSEOContent/' + this.activitySlug)
            .then(res => res.json()).catch(error => {
                this.$router.push({
                    path: '/'
                })
                console.error("There was an error!", error); return false;
            });
    },
    mounted() {
        this.getPageData();
    },
    methods: {
        metaDesc() {
            if (this.seoData && this.seoData.description) {
                return this.seoData.description
            } else {
                return 'goan recipes, goan vegetarian recipes, goan chicken recipes, goan breakfast recipes, goan cake recipes, goan pasta recipes, goan dinner recipes, goan mushroom recipes, goan salad recipes, goan food recipes'
            }
        },
        metaKeywords() {
            if (this.seoData && this.seoData.keywords) {
                return this.seoData.keywords;
            } else {
                return 'goan recipes, goan vegetarian recipes, goan chicken recipes, goan breakfast recipes, goan cake recipes, goan pasta recipes, goan dinner recipes, goan mushroom recipes, goan salad recipes, goan food recipes'
            }
        },
        metaImage() {
            if (this.seoData && this.seoData.image) {
                return this.seoData.image;
            } else {
                return 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D'
            }
        },

        async getPageData() {
                this.listings = await fetch(this.$config.fetchUrl + '/api/posts/app/getRecipeBySlug/' + this.activitySlug)
                    .then(res => res.text()).catch(error => {
                        console.error("There was an error!", error); return false;
                    });
                this.$nextTick(() => {
                    this.populateData(this.listings);
                })

        },

        populateData(data) {
            this.listings = this.getCryptKey(data);
            this.$nextTick(() => {
                this.loading = false;
                this.offerLoading = false;
            })
        },

        getTermsArr(terms) {
            let arr = terms.split("\n")
            arr = arr.filter(item => item);
            return arr
        },


        async getAllData() {
            //Get the list of post data
            this.listings = await fetch(this.$config.fetchUrl + '/api/posts/app/getPostBySlug/' + this.activitySlug)
                .then(res => res.text()).catch(error => {
                    this.$router.push({
                        path: '/'
                    })
                    console.error("There was an error!", error); return false;
                });
            this.listings = this.getCryptKey(this.listings);
            this.$nextTick(() => {
                this.loading = false;
                this.offerLoading = false;
            })
            this.relatedPlaces = await fetch(this.$config.fetchUrl + '/api/posts/app/getNearbyPlaces/' + this.activitySlug)
                .then(res => res.text())
            this.relatedPlaces = this.getCryptKey(this.relatedPlaces);
            this.relatedActivities = await fetch(this.$config.fetchUrl + '/api/posts/app/getNearbyActivities/' + this
                .activitySlug)
                .then(res => res.text())
            this.relatedActivities = this.getCryptKey(this.relatedActivities);
            this.touristDestSchema = this.relatedActivities.map(v => ({
                "@type": ["TouristAttraction"],
                "name": v.post && v.post.title ? v.post.title : 'Goa App',
                "image": v.post && v.post.gallery ? v.post.gallery : [],
                "sameAs": v.post && v.post.slug ? `https://goa.app/activities/${v.post.slug}` : 'Goa App'
            }));
            this.reviews = await fetch(this.$config.fetchUrl + '/api/posts/app/getReviews/' + this.activitySlug)
                .then(res => res.text())
            this.reviews = this.getCryptKey(this.reviews);
        },

        string_to_slug(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        // remove accents, swap ñ for n, etc
        var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to = "aaaaaeeeeiiiioooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes
        return str;
      },

        // To add a fallback placeholder image if not rendereds from API
        setFallbackImageUrl(event) {
            event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
        },

        getLatLongForMap() {
            if (this.listings.post && this.listings.post.location && this.listings.post.location.latitude && this.listings
                .post.location.longitude) {
                return this.listings.post.location.latitude + "," + this.listings.post.location.longitude
            }
            return ""
        },
        getGuidelineArr(guideline) {
            let arr = guideline.split("\n")
            arr = arr.filter(item => item);
            return arr
        },

        // Store filters in Localstorage
        scrollHere(item) {
            this.$nextTick(() => {
                this.scrollToJsOffers(item)
            })
        },

        goTotags(tag) {
        let tagSlug = this.string_to_slug(tag)
        this.$router.push({
          path: "/tags/" + tagSlug
        });
      },
    }
  }
  